import { render, staticRenderFns } from "./StarScore.vue?vue&type=template&id=f323980e&scoped=true"
import script from "./StarScore.vue?vue&type=script&lang=js"
export * from "./StarScore.vue?vue&type=script&lang=js"
import style0 from "./StarScore.vue?vue&type=style&index=0&id=f323980e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f323980e",
  null
  
)

export default component.exports